import { Component, OnInit, Input } from '@angular/core';
import { FormFooter } from '../../../../core/models/physician/form-doc-builder';
import { MatSnackBar } from '@angular/material';
import { FormService } from '../../../../core/services/v2/form.service';
import { WindowLoaderService } from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-form-footer',
  templateUrl: './form-footer.component.html',
  styleUrls: ['./form-footer.component.scss']
})
export class FormFooterComponent implements OnInit {
  @Input() formFooter: FormFooter;
  @Input() formId: number;
  pictureForm = new FormData();
  fileName: string;

  constructor(
    private _formService: FormService,
    private _loaderService: WindowLoaderService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    if (!this.formFooter) {
      this.formFooter = new FormFooter();
    }
  }

  removeFooterImgUrl() {
    this.formFooter.imageUrl = "";
  }
  attachPicture(event) {

    this._loaderService.show();
    const file = event.target.files[0];
    this.pictureForm.append('ImageSource', file);
    this.pictureForm.append('FormId', this.formId.toString());
    //const url = URL.createObjectURL(file);
    //this.headerImageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this._formService.uploadFooterPicture(this.formId, this.pictureForm).subscribe(
      (res) => {
        if (res.resultStatus.isSuccess) {

          this.formFooter.imageUrl = res.result;
          this._snackBar.open("Picture was successfully uploaded", "Ok", {
            duration: 5000
          });
        } else {
          console.error(res);
          this._snackBar.open("Picture could not be uploaded", "Ok", {
            duration: 5000
          });

        }
      },
      (error) => {
        console.error(error);
        this._snackBar.open("Picture could not be uploaded", "Ok", {
          duration: 5000
        });
      }, () => {
        this._loaderService.hide();

      }
    );
  }
}
